import { defaultTo } from 'ramda';
import { IRecommendedServicePackageV2 } from '../../../../repositories/billing-tariffs/entities/PublishTerms/RecommendedServicePackageV2';
import {
  ERecommendedPackagePublishType,
  EPackageType,
  ERecommendedPackageType,
  IRecommendedPackage,
} from '../../../../types/reducers/recommendedPackages';
import { mapPackageService } from './mapPackageService';
import uniqueId from 'lodash/uniqueId';
import { mapGift } from './gifts';

export const mapRecommendedPackage = (recommendedPackage: IRecommendedServicePackageV2): IRecommendedPackage => {
  const {
    id,
    type,
    headerText,
    tooltipText,
    durationInDays,
    regionNames,
    categoriesView,
    price,
    discountPercent,
    marketingPrice,
    announcementPrice,
    packageStartDate,
    packageEndDate,
    totalAnnouncementsCount,
    totalAuctionPointsCount,
    services,
    polygonIds,
    categoriesIds,
    packageType,
  } = recommendedPackage;

  const publishType = recommendedPackage.publishType as string as ERecommendedPackagePublishType;

  const gifts = defaultTo([], recommendedPackage.gifts);

  return {
    id: uniqueId(),
    packageId: id,
    autoProlong: false,
    headerText: defaultTo('', headerText),
    tooltipText: defaultTo('', tooltipText),
    durationInDays,
    regionNames,
    categoriesView,
    price,
    discountPercent,
    marketingPrice,
    pricePerOffer: announcementPrice,
    packageStartDate,
    packageEndDate,
    totalPublicationCount: totalAnnouncementsCount,
    totalAuctionPoints: totalAuctionPointsCount,
    selected: false,
    services: services.map(mapPackageService),
    type: type as string as EPackageType,
    polygonIds,
    categoriesIds: defaultTo([], categoriesIds),
    publishType,
    packageType: packageType as string as ERecommendedPackageType,
    gifts: gifts.map(mapGift(publishType)),
  };
};
